export default "__VITE_ASSET__Dgox5coy__";